import React, { Component } from 'react';
import { connect } from 'react-redux';

import MobileMenu from 'components/organisms/app/mobileMenu';

class MobileMenuContainer extends Component {
    render() {
        return <MobileMenu {...this.props} />;
    }
}

function getCategories(projects) {
    let allCategories = projects.map(item => {
        return item.fields.category.fields;
    });

    //PHANTOMJS doesnt support Set
    // return [...new Set(allCategories)];
    return allCategories.filter((x, i, a) => a.indexOf(x) === i);
}

function createMenu(projects) {
    let categories = getCategories(projects);
    let items = [];

    items.push({
        title: 'All work',
        url: ''
    });

    categories.forEach(item => {
        items.push({
            title: item.title,
            url: `/filter/${item.slug}`
        });
    });

    items.push({
        title: 'Profile + Contact',
        url: '/profile'
    });

    return items;
}

const mapStateToProps = (state, ownProps) => {
    let projects = state.projects.all;
    let items = createMenu(projects);

    return {
        open: state.app.menu,
        items
    };
};

MobileMenuContainer = connect(mapStateToProps)(MobileMenuContainer);

export default MobileMenuContainer;



// WEBPACK FOOTER //
// ./src/data/containers/mobileMenu.js